import {MdOutlineChildFriendly, MdOutlineScubaDiving, MdOutlineSportsSoccer, MdSportsTennis} from "react-icons/md";
import {BsMusicNoteBeamed} from "react-icons/bs";
import {GrWorkshop} from "react-icons/gr";
import {ImSpoonKnife} from "react-icons/im";
import {FaChildren, FaPeopleGroup} from "react-icons/fa6";
import {BiChild, BiParty} from "react-icons/bi";
import {FaChild, FaUmbrellaBeach} from "react-icons/fa";
import {LuBike} from "react-icons/lu";
import {GiNothingToSay, GiWalkingBoot} from "react-icons/gi";
import {TbMoodSuprised} from "react-icons/tb";
import {GiMusicalNotes} from "react-icons/gi"
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
export const activitiesTags = [
	{
		id: "sports",
		name: "Sports",
		icon: <MdOutlineSportsSoccer size={30} />,
		color: "#fddc46"
	},
	{
		id: "entertainment",
		name: "Entertainment",
		icon: <BsMusicNoteBeamed size={30} />,
		color: "#cc58ff"
	},
	{
		id: "mind",
		name: "Mindfulness",
		icon: <SelfImprovementIcon style={{fontSize: 30}}/>,
		color: "#5aeDa8"
	},
	{
		id: "diving",
		name: "Diving",
		icon: <MdOutlineScubaDiving size={30} />,
		color: "#ff83a4"
	},
	{
		id: "kids",
		name: "Kids",
		icon: <FaChildren size={30} />,
		color: "#ffa726"
	},
	{
		id: "babies",
		name: "Babies",
		icon: <MdOutlineChildFriendly size={30} />,
		color: "#66bb6a"
	},
	{
		id: "kids4m",
		name: "Kids 4m-2",
		icon: <BiChild size={30} />,
		color: "#ff4081"
	},
	{
		id: "kids3",
		name: "Kids 3-5",
		icon: <FaChild size={30} />,
		color: "#2979ff"
	},
	{
		id: "kids5",
		name: "Kids 5-8",
		icon: <FaChild size={30} />,
		color: "#f4511e"
	},
	{
		id: "kids4",
		name: "Kids 4-8",
		icon: <FaChild size={30} />,
		color: "#9c27b0"
	},
	{
		id: "kids6",
		name: "Kids 3-6",
		icon: <FaChild size={30} />,
		color: "#8bc34a"
	},
	{
		id: "kids7",
		name: "Kids 7-9",
		icon: <FaChild size={30} />,
		color: "#e91e63"
	},
	{
		id: "kids10",
		name: "Kids 10-12",
		icon: <FaChild size={30} />,
		color: "#3f51b5"
	},
	{
		id: "kids14",
		name: "Kids 9-14",
		icon: <FaChild size={30} />,
		color: "#ff5722"
	},
	{
		id: "kids9",
		name: "Kids 9-12",
		icon: <FaChild size={30} />,
		color: "#4caf50"
	},
	{
		id: "teens",
		name: "Teens",
		icon: <FaChildren size={30} />,
		color: "#ff9800"
	},
	{
		id: "young",
		name: "Youngsters",
		icon: <FaPeopleGroup size={30} />,
		color: "#673ab7"
	},
	{
		id: "workshops",
		name: "Workshops",
		icon: <GrWorkshop size={30} />,
		color: "#009688"
	},
	{
		id: "parties",
		name: "Parties",
		icon: <BiParty size={30} />,
		color: "#ffc107"
	},
	{
		id: "dance",
		name: "Dance",
		icon: <GiMusicalNotes size={30} />,
		color: "#ff6f00"
	},
	{
		id: "bikes",
		name: "Bikes",
		icon: <LuBike size={30} />,
		color: "#3f51b5"
	},
	{
		id: "tennis",
		name: "Tennis",
		icon: <MdSportsTennis size={30} />,
		color: "#fbc02d"
	},
	{
		id: "fitness",
		name: "Fitness",
		icon: <FitnessCenterIcon style={{fontSize:30}} />,
		color: "#8B6F4B"
	},
	{
		id: "beach",
		name: "Beach",
		icon: <FaUmbrellaBeach size={30} />,
		color: "#9c27b0"
	},
	{
		id: "other",
		name: "Other",
		icon: <GiNothingToSay size={30} />,
		color: "#ff4081"
	},
	{
		id: "dining",
		name: "Dining",
		icon: <ImSpoonKnife size={30} />,
		color: "#4caf50"
	},
	{
		id: "excursions",
		name: "Excursions",
		icon: <GiWalkingBoot size={30} />,
		color: "#ffc107"
	},
	{
		id: "experiences",
		name: "Experiences",
		icon: <TbMoodSuprised size={30} />,
		color: "#009688"
	}
];


export const getActivityDisplayName = (activityTag, activity, lang) =>
	(activity?.activity?.name?.[lang] || activity?.activity?.name?.en || activity?.activity?.name?.text) || (activityTag?.name?.[lang] || activityTag?.name?.en || activityTag?.name?.text) || "";

export const getActivityDescription = (activityTag, activity, lang) =>
	activity?.activity?.description?.[lang] || activity?.activity?.description?.en || activity?.activity?.description?.text || activityTag?.description?.[lang] || activityTag?.description?.en || activityTag?.description?.text || "";

export const concatActivityIconAndTagsOverrides = (entries, tagOverrides, lang) => {
	return entries.map((entry) => {
		const tag = activitiesTags.find((tag) => tag.id === entry.id);
		const tagOverride = tagOverrides && tagOverrides[entry.id];
		
		if (tagOverride && Object.keys(tagOverride).length > 0) {
			return {
				id: entry.id,
				name:
					(tagOverride?.name?.[lang] || tagOverride?.name?.en || tagOverride?.name?.text) != null ? tagOverride.name : entry.name,
				icon: tag.icon,
				...((tagOverride?.description?.[lang] || tagOverride?.description?.en || tagOverride?.description?.text) != null && {
					description: tagOverride?.description?.[lang] || tagOverride?.description?.en || tagOverride?.description?.text,
				}),
				iconMui: tagOverride?.iconMui,
				color: tagOverride?.color ? tagOverride.color : tag.color,
			};
		} else if (tag) {
			return {
				id: entry.id,
				name: entry.name,
				icon: tag.icon,
				color: tag.color
			};
		}
		return entry;
	});
};


